<div class="main container-fluid">
	<div class="page-header">
		<h1>{{LOCALIZATION.workflowHome}}</h1>
	</div>
	<div *ngIf="!ready" class="row" style="margin-bottom: 20px;">
		<div class="col-sm-12 alert-danger text-center">{{LOCALIZATION.workflowUnavailable}}</div>
	</div>
	
	<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav nav-tabs nav-justified">
	  <li class="nav-item" *ngFor="let tab of tabs; let i = index" [ngbNavItem]="i" [hidden]="tab.hide || !tab.canaccess">
	    <a class="nav-link" ngbNavLink (click)="activeTab = tab.id">
	      {{ tab.title }}
	    </a>
	  </li>
	</ul>
	<div [ngbNavOutlet]="nav"></div>
	
	<div class="content-container dx-content">
	  <ng-container [ngSwitch]="activeTab">
	    <workflow-batches *ngSwitchCase="'batches'"></workflow-batches>
	    <workflow-my-tasks *ngSwitchCase="'mytasks'"></workflow-my-tasks>
	    <workflow-unclaimed-tasks *ngSwitchCase="'tasks'"></workflow-unclaimed-tasks>
	    <workflow-referrals *ngSwitchCase="'referrals'"></workflow-referrals>
	    <workflow-batches *ngSwitchDefault></workflow-batches> <!-- Default tab -->
	  </ng-container>
	</div>
</div>	